import { React, useState, TextField, InputAdornment, IconButton, SearchIcon, useEffect } from '../../utils/globalImports';

interface SearchBarProps {
  onQueryChange: (query: string) => void; // Notify parent about query changes
  placeholder?: string;              // Optional placeholder text for the input
  sx?: React.CSSProperties;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  isClear?: boolean; // Optional prop to show/hide clear button
  setIsClear?:any; // Optional prop for handling key down events
}

const SearchBar: React.FC<SearchBarProps> = ({ onQueryChange, placeholder = "Search...", sx, isClear = false, onKeyDown ,setIsClear}) => {
  const [query, setQuery] = useState<string>('');

  // Handle the change in the search input field
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedQuery = event.target.value;
    setQuery(updatedQuery);
    onQueryChange(updatedQuery); // Notify parent about query changes
  };

  useEffect(() => {
    if (isClear) {
      setQuery('');
      setIsClear(false);
    } }, [isClear]);

  return (
    <div>
      <TextField
        value={query}
        onChange={handleInputChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        sx={{
          ...sx,
          backgroundColor: '#fff',
          borderRadius: '30px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '30px',
            height: '43px',
            display: 'flex',
            alignItems: 'center', // Vertically center the input & adornment
          },
          '& .MuiInputBase-input': {
            fontSize: '12px', // Set the font size here
            padding: '8px 12px', // Adjust padding to align with other controls
          },
        }}
        slotProps={{
          input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                aria-label="search"
                disabled={!query.trim()} // Disable the button if the query is empty
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }
        }}
      />
    </div>
  );
};

export default SearchBar;
